import { GameElementDto } from '../../../hooks/gameElements';

import { Gift, PublicationDraft } from './types';

const GIFT_WRAP_ICONIC_ID = '9d212423-365d-4d0f-a220-98562baa3aad';

export const PLACEHOLDER_GIFT: Gift = {
    contents: [],
    wrapperGameElementId: GIFT_WRAP_ICONIC_ID,
};

export function defaultPublicationDraft(): PublicationDraft {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() + 1);
    const end = new Date(start);
    end.setDate(end.getDate() + 7);
    return {
        startDate: start,
        endDate: end,
    };
}

export function isGiftWrap(gameElement: GameElementDto) {
    return gameElement.name.includes('GiftWrapIconic');
}

export function generateCSharpCode(gift: Gift): string {
    const startDate = new Date(gift.startDate!);
    const endDate = new Date(gift.endDate!);

    const contentsStr = gift
        .contents!.map((id) => `Guid.Parse("${id}")`)
        .join(', ');

    return `public static readonly AvailableGift TutorialGift = new(
\tGuid.Parse("${gift.id}"),
\tnew List<Guid> { ${contentsStr} },
\tGuid.Parse("${gift.wrapperGameElementId}"),
\tnew DateTime(${startDate.getUTCFullYear()}, ${startDate.getUTCMonth() + 1}, ${startDate.getUTCDate()}),
\tnew DateTime(${startDate.getUTCFullYear()}, ${startDate.getUTCMonth() + 1}, ${startDate.getUTCDate()}),
\tnew DateTime(${endDate.getUTCFullYear()}, ${endDate.getUTCMonth() + 1}, ${endDate.getUTCDate()})
);
`;
}
